import api from './api';

/**
 * Patient interaction history (GP-1508) — the topbar history menu.
 *
 * The list is recorded entirely server-side (order action logs + Patient 360
 * opens), so there is nothing to POST from here: the frontend only reads.
 */

/** One interaction row, as returned by `GET /api/patient-interactions/:pharmacyId`. */
export interface PatientInteraction {
  id: string;
  patientId: string;
  pharmacyId: string;
  /** `<pharmacyId>_<patientId>` — route straight to `/patients/<compositePatientId>`. */
  compositePatientId: string;
  patientName?: string | null;
  /** Raw action string (an OrderActionType value, or `patient_profile_viewed`). */
  action: string;
  /** Display label resolved by the API — never re-derive it here (one source of truth). */
  actionLabel: string;
  orderId?: string | null;
  orderNumber?: string | null;
  rxNumbers?: string[] | null;
  stage?: string | null;
  /** ISO 8601 timestamp. */
  createdAt: string;
}

export const PATIENT_INTERACTIONS_DEFAULT_LIMIT = 50;

/** The calling user's own interactions for one pharmacy, newest first. */
export const getPatientInteractions = async (
  pharmacyId: string,
  limit: number = PATIENT_INTERACTIONS_DEFAULT_LIMIT,
): Promise<PatientInteraction[]> => {
  const response = await api.get<PatientInteraction[]>(
    `/api/patient-interactions/${pharmacyId}`,
    { params: { limit } },
  );
  return response.data ?? [];
};

export default { getPatientInteractions };
